document.addEventListener('change',event=>{if(event.target.matches('[data-variant-selector]')){const url=new URL(location.href);url.searchParams.set('variant',event.target.value);url.searchParams.delete('selling_plan');location.assign(url.toString());}});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.header details[open]').forEach(el=>{el.open=false;el.querySelector('summary').focus();});}});
document.addEventListener('click',event=>{document.querySelectorAll('.header details[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;});});

document.addEventListener('submit',async event=>{
const form=event.target;
if(!form.matches('.cart-form')||!['update','checkout'].includes(event.submitter?.name))return;
event.preventDefault();
const button=event.submitter;
button.disabled=true;
let error=form.querySelector('[data-cart-error]');
if(!error){error=document.createElement('p');error.dataset.cartError='';error.setAttribute('role','alert');form.append(error);}
error.textContent='';
try{
const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{method:'POST',body:new FormData(form)});
const result=await response.json();
if(!response.ok)throw new Error(result.description||'Bijwerken is niet gelukt. Probeer het opnieuw.');
if(button.name==='checkout'){location.assign((window.Shopify?.routes?.root||'/')+'checkout');}else{location.reload();}
}catch(failure){error.textContent=failure.message;button.disabled=false;}
});

